import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    ngpForm: {
        paddingLeft: theme.spacing(3),
    },
    requiredFieldsTip: {
        marginRight: theme.spacing(2),
        textAlign: 'right',
        color: theme.palette.error.main,
    },
    ngpFormSectionContainer: {
        marginBottom: theme.spacing(6),
        marginRight: theme.spacing(2),
    },
    ngpFormNoPadding: {},
    ngpFormFields: {
        paddingLeft: theme.spacing(2),
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.flexDirectionColumn,

        '& .MuiTextField-root': {
            display: 'block',
            marginTop: theme.spacing(3),
        },

        '& .MuiFormControlLabel-root': {
            marginTop: theme.spacing(3),
        },

        '& .MuiSelect-root': {
            minWidth: 125,
        },
    },
    ngpFormField: {},
    ngpFormFieldContainer: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.flexDirectionRow,
    },
    ngpBottomActions: {
        marginTop: theme.spacing(5),

        '& .hideSave': {
            display: 'none',
        },

        '@media print': {
            display: 'none',
        },
    },
    emptySelectOption: {
        height: 36,
    },
}));

// Customer ngpFormFields Padding Left
export const useNoPaddingLeftStyles = makeStyles((theme) => ({
    ngpFormFields: {
        paddingLeft: theme.spacing(0),
    },
}));

export const usePaddingLeftStyles = makeStyles((theme) => ({
    ngpFormFields: {
        paddingLeft: theme.spacing(2),
        '& .MuiFormControlLabel-root': {
            marginTop: theme.spacing(0.125),
        },
    },
}));
